export enum BankAccountTypes {
  checking = "checking",
  saving = "savings",
}

export const useBankAccountType = (): BankAccountTypes[] => {
  return [BankAccountTypes.checking, BankAccountTypes.saving];
};
